import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaNumberNode } from './TypedNode'
import { SchemaNumberModel } from './ViewModel'

export const SchemaNumberPlugin = createSchemaPlugin(
  'Schema.Number',
  SchemaNumberModel,
  SchemaNumberNode
)
